import { FC, ReactNode } from 'react';
import { AllieGoBackLink } from '../GoBackLink';
import { AlliePageTitle } from '../PageTitle';
import { AllieCard, AllieText } from '../../../components';
import { AllieComments, AllieCommentsProps } from '../Comments';
import { Details, DetailsProps } from './components/Details/Details';
import { AllieChecklist, AllieChecklistProps } from '../Checklist';
import './DetailLayout.desktop.css';

const namespace = 'allie-detail-layout-desktop';

export interface DetailLayoutDesktopProps {
  title: string;
  description?: string;
  contentAttachments?: ReactNode;
  goBackLink: string;
  labels: {
    description: string;
    checklist: string;
    activity: string;
  };
  commentsProps?: AllieCommentsProps;
  checklistProps?: AllieChecklistProps;
  detailsProps: DetailsProps;
}

export const AllieDetailLayoutDesktop: FC<DetailLayoutDesktopProps> = ({
  title,
  description,
  contentAttachments,
  labels,
  commentsProps,
  checklistProps,
  detailsProps,
  goBackLink,
}) => {
  return (
    <main className={namespace}>
      <div className={`${namespace}__header`}>
        <AllieGoBackLink href={goBackLink} />
        <AlliePageTitle>{title}</AlliePageTitle>
      </div>
      <div className={`${namespace}__cards`}>
        <div className={`${namespace}__cards-summary`}>
          <AllieCard
            content={{
              children: (
                <div className={`${namespace}__card-description__content`}>
                  <div>
                    <AllieText type="h4">{labels.description}</AllieText>
                    <AllieText
                      className={`${namespace}__card-description__content__description`}
                      type="body2"
                      color="neutral-90"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >
                      {description}
                    </AllieText>
                  </div>
                  {contentAttachments}
                </div>
              ),
            }}
            className={`${namespace}__card-description`}
          />
          <AllieCard
            content={{
              children: (
                <div className={`${namespace}__card-description__content`}>
                  <AllieText type="h4">{labels.checklist}</AllieText>
                  <div className={`${namespace}__card-description__content__activity`}>
                    {checklistProps && <AllieChecklist {...checklistProps} />}
                  </div>
                </div>
              ),
            }}
            className={`${namespace}__card-description`}
          />
          <AllieCard
            content={{
              children: (
                <div className={`${namespace}__card-description__content`}>
                  <AllieText type="h4">{labels.activity}</AllieText>
                  {commentsProps && <div className={`${namespace}__card-description__content__activity`}>
                    {commentsProps && <AllieComments {...commentsProps} />}
                  </div>}
                </div>
              ),
            }}
            className={`${namespace}__card-description`}
          />
        </div>
        <AllieCard
          content={{
            children: (
              <div>
                <Details {...detailsProps} />
              </div>
            ),
          }}
          className={`${namespace}__card-detail`}
        />
      </div>
    </main>
  );
};
